import React, { useEffect, useRef, useState } from "react";
import { ListItemText, Tooltip } from "@mzc-pdc/ui";

const EllipsisListItemText = ({ primary, primaryTypographyProps, tooltipPlacement = "right", ...rest }) => {
    const ref = useRef(null);
    const [isOverflow, setIsOverflow] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return undefined;

        const check = () => setIsOverflow(el.scrollWidth > el.clientWidth);
        check();

        const observer = new ResizeObserver(check);
        observer.observe(el);
        return () => observer.disconnect();
    }, [primary]);

    return (
        <Tooltip title={isOverflow ? primary : ""} placement={tooltipPlacement}>
            <ListItemText
                primary={primary}
                primaryTypographyProps={{ ...primaryTypographyProps, ref }}
                {...rest}
            />
        </Tooltip>
    );
};

export default EllipsisListItemText;
